export default [
    {
        path: '/prerequisite/expense-categories',

        name: 'Expense Categories',

        component: () => import('@/views/prerequisite/expense-categories'),
    },
];